import { Result } from "domain/entities/result";
import { TypeInteractionRepository } from "domain/repositories";

export default class DeleteUseCase {
    private typeInteractionRepository: TypeInteractionRepository;
    
    public constructor(typeInteractionRepository: TypeInteractionRepository) {
        this.typeInteractionRepository = typeInteractionRepository
    }

    public async deleteTypeInteraction(id: number, token: Promise<[string | null, string | null]>): Promise<[Result, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.typeInteractionRepository.deleteTypeInteraction(id, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}